// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  HOME_SET_CURRENT_SEASON,
} from './constants';

import { orderBy } from '../../common/orderby';
import {setSelectedSchedule} from './setSelectedSchedule'

export function setCurrentSeason(seasonId) {
  return (dispatch, getState) => { 
    dispatch({
      type: HOME_SET_CURRENT_SEASON,
      data: seasonId
    });
    let state = getState();
    //console.log({state, schedules: state.home.schedules});
    let schedules = orderBy(Object.values(state.home.schedules).filter(s => s.seasonId == seasonId), s => [s.creation]).slice(-2);
    if (schedules)
      schedules.reverse();
    let bestSchedule = schedules && schedules[0];
    let secondBestSchedule = schedules && schedules[1];
    //console.log({schedules});
    for (let key of ["main","diff"])
    {
      if (!state.home.selectedSchedules || 
        !state.home.selectedSchedules[key] ||
        state.home.schedules[state.home.selectedSchedules[key]].seasonId != seasonId)
      {
        //dispatch(setSelectedSchedule(key, key === "diff" ? secondBestSchedule && secondBestSchedule.id: bestSchedule && bestSchedule.id));
        dispatch(setSelectedSchedule(key, key === "diff" ? undefined: bestSchedule && bestSchedule.id));
      }
    }

  }
  
}

export function reducer(state, action) {
  switch (action.type) {
    case HOME_SET_CURRENT_SEASON:
      return {
        ...state,
        currentSeasonId: action.data
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/home/redux/setCurrentSeason.js